var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-auth"},[_vm._t("default"),_c('y-loading',{attrs:{"active":_vm.$wait.is('loading-page'),"height":"100vh","size":"50px"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }